var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 12.8752C12.1655 12.8752 13.9211 11.1404 13.9211 9.00036C13.9211 6.86033 12.1655 5.12549 9.99995 5.12549C7.83436 5.12549 6.0788 6.86033 6.0788 9.00036C6.0788 11.1404 7.83436 12.8752 9.99995 12.8752Z",
    stroke: "#737A83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6693 5.18163C15.866 5.45988 16.0382 5.75426 16.184 6.06155L18.2998 7.22402C18.564 8.39332 18.5667 9.60551 18.3079 10.776L16.184 11.9384C16.0382 12.2457 15.866 12.5401 15.6693 12.8184L15.7102 15.2159C14.8135 16.0234 13.7522 16.6317 12.5978 17L10.5147 15.7649C10.172 15.7891 9.82801 15.7891 9.48535 15.7649L7.41041 16.9919C6.25228 16.6304 5.18752 16.0244 4.28982 15.2159L4.33067 12.8264C4.13565 12.5443 3.96356 12.2474 3.81602 11.9384L1.70023 10.776C1.43604 9.60668 1.43325 8.39449 1.69206 7.22402L3.81602 6.06155C3.96182 5.75426 4.134 5.45988 4.33067 5.18163L4.28982 2.78406C5.1865 1.9766 6.24777 1.36828 7.40224 1L9.48535 2.23512C9.82801 2.21089 10.172 2.21089 10.5147 2.23512L12.5896 1.00807C13.7477 1.36964 14.8125 1.97562 15.7102 2.78406L15.6693 5.18163Z",
    stroke: "#737A83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomInactive);
export default __webpack_public_path__ + "static/media/custom-inactive.309b07a0fe44c87f1cdfdea975222588.svg";
export { ForwardRef as ReactComponent };